<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Điểm danh"
          :link="[
            { text: 'Lớp học', href: '../class-attendance' },
            { text: 'Điểm danh', href: '../class-attendance' },
          ]"
        />
      </div>
    </div>
    <div style="overflow-x: auto; overflow-y: hidden">
      <v-card class="mx-4 mb-0 pa-6" outlined>
        <ClassTimeTableFilter @onFilterChanged="handleFilterChange" />
      </v-card>
      <ClassAttendance />
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import get from 'lodash-es/get'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import ClassTimeTableFilter from '@/modules/timeTable/ClassTimeTableFilter.vue'
import ClassAttendance from '@/modules/ClassAttendance/ClassAttendance.vue'
import dayjs from 'dayjs'

export default {
  name: 'ClassAttendanceView',

  components: {
    Breadcrumbs,
    ClassTimeTableFilter,
    ClassAttendance,
  },

  beforeDestroy() {
    this.setOneClass(null)
  },

  methods: {
    ...mapActions({
      fetchOneClass: 'class/fetchOneClass',
      fetchLessons: 'lesson/fetchLessons',
    }),

    ...mapMutations({
      setOneClass: 'class/setOneClass',
    }),

    async handleFilterChange(data) {
      const classId = get(data, 'class.id')
      if (!classId) {
        return this.$alert.error('Vui lòng chọn "lớp học"')
      }

      try {
        await Promise.all([
          this.fetchOneClass(classId),
          this.fetchLessons({ class: classId, date_lte: dayjs().endOf('day').toISOString(), _sort: {date: -1} }),
        ])
      } catch (error) {
        this.$alert.error('Lỗi tải buổi học')
      }
    },
  },
}
</script>
